import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import { getRouteProcedure } from '../utils/menu-mapping';
import { zainstalujPamiecWejsc } from '../utils/partner-origin';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginPage.vue'),
  },
  {
    path: '/employee',
    component: () => import('../views/employee/EmployeeLayout.vue'),
    meta: { requiresAuth: true, userType: 'employee' },
    children: [
      {
        path: '',
        redirect: '/employee/affairs',
      },
      {
        path: 'affairs',
        name: 'AffairsList',
        component: () => import('../views/employee/AffairsListPage.vue'),
      },
      {
        path: 'affair/:id',
        name: 'AffairDetails',
        component: () => import('../views/employee/AffairDetailsPage.vue'),
      },
      {
        path: 'dashboard',
        name: 'EmployeeDashboard',
        component: () => import('../views/employee/EmployeeDashboard.vue'),
      },
      {
        path: 'partners',
        name: 'PartnersList',
        component: () => import('../views/employee/PartnersListPage.vue'),
      },
      {
        path: 'partner/:id',
        name: 'PartnerDetails',
        component: () => import('../views/employee/PartnerDetailsPage.vue'),
      },
      {
        path: 'partner/:id/sales',
        name: 'PartnerSales',
        component: () => import('../views/employee/PartnerSalesPage.vue'),
      },
      {
        path: 'partner/:id/invoices',
        name: 'PartnerInvoices',
        component: () => import('../views/employee/PartnerInvoicesPage.vue'),
      },
      {
        path: 'partner/:id/invoice/:invoiceId',
        name: 'PartnerInvoiceDetails',
        component: () => import('../views/contractor/InvoiceDetailsPage.vue'),
      },
      {
        path: 'partner/:id/products',
        name: 'PartnerProducts',
        component: () => import('../views/shared/ProductsListPage.vue'),
      },
      {
        path: 'partner/:id/favorite-products',
        name: 'PartnerFavoriteProducts',
        component: () => import('../views/contractor/FavoriteProductsPage.vue'),
      },
      {
        path: 'partner/:id/affairs',
        name: 'PartnerAffairs',
        component: () => import('../views/employee/PartnerAffairsPage.vue'),
      },
      {
        path: 'partner/:id/route-planning',
        name: 'PartnerRoutePlanning',
        component: () => import('../views/employee/RoutePlanningPage.vue'),
      },
      {
        path: 'nearby-partners',
        name: 'NearbyPartners',
        component: () => import('../views/employee/NearbyPartnersPage.vue'),
      },
      {
        path: 'weekly-report',
        name: 'WeeklyReport',
        component: () => import('../views/employee/WeeklyReportPage.vue'),
      },
      {
        path: 'team',
        name: 'ManagerDashboard',
        component: () => import('../views/employee/ManagerDashboardPage.vue'),
      },
      // Pomoc CELOWO bez wpisu w ROUTE_PROCEDURE_MAPPING — instrukcja jest
      // dla każdego zalogowanego, niezależnie od uprawnień do procek.
      {
        path: 'pomoc',
        name: 'Help',
        component: () => import('../views/employee/HelpPage.vue'),
      },
      {
        path: 'pomoc/:slug',
        name: 'HelpTopic',
        component: () => import('../views/employee/HelpPage.vue'),
      },
      {
        path: 'new-partner',
        name: 'NewPartner',
        component: () => import('../views/employee/NewPartnerPage.vue'),
      },
      {
        path: 'sales-report',
        name: 'SalesReport',
        component: () => import('../views/employee/SalesReportPage.vue'),
      },
      {
        path: 'wz',
        name: 'WzList',
        component: () => import('../views/employee/WzListPage.vue'),
      },
      {
        path: 'wz/:id',
        name: 'WzDetails',
        component: () => import('../views/employee/WzDetailsPage.vue'),
      },
      {
        path: 'wz-expedition',
        name: 'WzExpedition',
        component: () => import('../views/employee/WzExpeditionPage.vue'),
      },
      {
        path: 'sales-analysis',
        name: 'SalesAnalysis',
        component: () => import('../views/employee/SalesAnalysisPage.vue'),
      },
      {
        path: 'sales-growth',
        name: 'SalesGrowth',
        component: () => import('../views/employee/SalesGrowthPage.vue'),
      },
      {
        path: 'financial-statement',
        name: 'FinancialStatement',
        component: () => import('../views/employee/FinancialStatementPage.vue'),
      },
      {
        path: 'account-analysis',
        name: 'AccountAnalysis',
        component: () => import('../views/employee/AccountAnalysisPage.vue'),
      },
      {
        path: 'rlt',
        name: 'Rlt',
        component: () => import('../views/employee/RltPage.vue'),
      },
      {
        path: 'finance-cockpit',
        name: 'FinanceCockpit',
        component: () => import('../views/employee/FinanceCockpitPage.vue'),
      },
      {
        path: 'invoice-verification',
        name: 'InvoiceVerificationList',
        component: () => import('../views/employee/InvoiceVerificationListPage.vue'),
      },
      {
        path: 'invoice-verification/:id',
        name: 'InvoiceVerificationDetails',
        component: () => import('../views/employee/InvoiceVerificationDetailsPage.vue'),
      },
      {
        path: 'invoice-verification-foreign',
        name: 'InvoiceVerificationForeignList',
        component: () => import('../views/employee/InvoiceVerificationForeignListPage.vue'),
      },
      {
        path: 'invoice-verification-foreign/:id',
        name: 'InvoiceVerificationForeignDetails',
        component: () => import('../views/employee/InvoiceVerificationForeignDetailsPage.vue'),
      },
      {
        path: 'partner-analysis',
        name: 'PartnerAnalysis',
        component: () => import('../views/employee/PartnerAnalysisPage.vue'),
      },
      {
        path: 'transport-planning',
        name: 'TransportPlanning',
        component: () => import('../views/employee/TransportPlanningPage.vue'),
      },
      {
        path: 'pricelist',
        name: 'Pricelist',
        component: () => import('../views/employee/PricelistPage.vue'),
      },
      {
        // Diagnostyka mostu natywnego i mikrofonu — wchodzi się z kafelka
        // w trybie deweloperskim albo wprost adresem /employee/diag.
        path: 'diag',
        name: 'Diagnostics',
        component: () => import('../views/employee/DiagnosticsPage.vue'),
      },

      // Products and Cart - HIDDEN for KioskAgent v2.0
      // {
      //   path: 'products',
      //   name: 'EmployeeProducts',
      //   component: () => import('../views/shared/ProductsListPage.vue'),
      // },
      {
        path: 'cart',
        name: 'EmployeeCart',
        component: () => import('../views/shared/CartPage.vue'),
      },
    ],
  },
  // Contractor routes
  {
    path: '/contractor',
    component: () => import('../views/contractor/ContractorLayout.vue'),
    meta: { requiresAuth: true, userType: 'contractor' },
    children: [
      {
        path: '',
        redirect: '/contractor/dashboard',
      },
      {
        path: 'dashboard',
        name: 'ContractorDashboard',
        component: () => import('../views/contractor/ContractorDashboard.vue'),
      },
      {
        path: 'products',
        name: 'ContractorProducts',
        component: () => import('../views/shared/ProductsListPage.vue'),
      },
      {
        path: 'cart',
        name: 'ContractorCart',
        component: () => import('../views/shared/CartPage.vue'),
      },
      {
        path: 'invoices',
        name: 'ContractorInvoices',
        component: () => import('../views/contractor/InvoicesListPage.vue'),
      },
      {
        path: 'invoice/:id',
        name: 'ContractorInvoiceDetails',
        component: () => import('../views/contractor/InvoiceDetailsPage.vue'),
      },
      {
        path: 'sales',
        name: 'ContractorSales',
        component: () => import('../views/contractor/ContractorSalesPage.vue'),
      },
      {
        path: 'favorite-products',
        name: 'ContractorFavoriteProducts',
        component: () => import('../views/contractor/FavoriteProductsPage.vue'),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

// Navigation guards
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  // Check authentication
  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    return next({ path: '/login', query: { redirect: to.fullPath } });
  }

  // Check session timeout
  if (authStore.isLoggedIn && authStore.isSessionExpired()) {
    authStore.logout();
    return next({ path: '/login', query: { redirect: to.fullPath } });
  }

  // Check user type
  if (to.meta.userType && to.meta.userType !== authStore.userType) {
    return next(`/${authStore.userType}/dashboard`);
  }

  // Check permissions for employee routes
  if (authStore.userType === 'employee' && to.path.startsWith('/employee')) {
    // Get procedure number for this route (exact path first, then patterns with params)
    const procedureNumber = getRouteProcedure(to.path);

    // If route requires a procedure and user doesn't have permission, redirect to dashboard
    if (procedureNumber && !authStore.hasPermission(procedureNumber)) {
      console.warn(`[Router] Access denied to ${to.path} - missing permission for proc ${procedureNumber}`);
      return next('/employee/dashboard');
    }
  }

  next();
});

// Skąd weszło się do karty kontrahenta - "Powrót" wraca tam (utils/partner-origin)
zainstalujPamiecWejsc(router);

// Każde wejście na trasę kontrahenta (/employee/partner/:id/...) synchronizuje
// authStore.selectedPartner ze ścieżką — koszyk wysyła zamówienie właśnie na
// selectedPartner, a wybór ustawiało dotąd tylko kliknięcie na liście
// kontrahentów (wejście z "Do odwiedzenia"/spraw/po SSO-relogu go omijało).
router.afterEach((to) => {
  const match = /^\/employee\/partner\/([^/]+)/.exec(to.path);
  if (match) {
    // dynamiczny import — unika cyklu router ↔ store ↔ apiClient przy starcie
    import('../composables/usePartnerContext').then(async ({ hydrateSelectedPartnerFromRoute }) => {
      const result = await hydrateSelectedPartnerFromRoute(match[1]);
      if (result !== 'denied') return;

      // Backend odmówił dostępu do tego kontrahenta. Ta jedna gałąź obsługuje
      // CAŁY obszar karty kontrahenta — sprzedaż, sprawy, faktury, produkty
      // i koszyk siedzą pod tą samą trasą, więc nie trzeba tego powtarzać
      // w każdym widoku. Bez tego strony zostawały puste bez wyjaśnienia.
      const [{ toastController }, { ACCESS_DENIED_MESSAGE }] = await Promise.all([
        import('@ionic/vue'),
        import('../utils/authz'),
      ]);
      const toast = await toastController.create({
        message: ACCESS_DENIED_MESSAGE,
        duration: 5000,
        color: 'warning',
        position: 'top',
      });
      await toast.present();
      router.replace('/employee/partners');
    });
  }
});

export default router;


